import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {PaginatedTableComponent} from '~shared/components/tables/paginated-table/paginated-table.component';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {CancellationTicket, Customer} from '~core/models';
import {InvoiceService} from '~core/services';
import {InvoiceOrderStatusTranslationsService} from '~shared/translations';


/**
 * Component class that displays the list of cancellations
 */
@UntilDestroy()
@Component({
  selector: 'app-page-cancellations-list',
  templateUrl: './page-cancellations-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class PageCancellationsListComponent implements OnInit, OnDestroy {
  @ViewChild(PaginatedTableComponent) paginatedTable: PaginatedTableComponent;
  public anim: any = '';
  public loading: boolean = true;
  public invoiceList: Array<CancellationTicket> = [];
  public options: UntypedFormGroup;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public baseApi: string;
  public customQueries: Array<any> = [];
  public defaultCustomQueries: Array<any> = [];
  @Input() public customer: Customer;

  constructor(
    public customerService: CustomerOverViewService,
    public invoiceOrderStatusTranslations: InvoiceOrderStatusTranslationsService,
    public tablesTranslations: TablesTranslations,
    public invoiceService: InvoiceService,
    private formBuilder: UntypedFormBuilder,
    public flTranslations: FormLabelTranslationService,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.invoiceService.castCancellationsListPage.pipe(untilDestroyed(this))
      .subscribe(data => this.invoiceList = data);
    this.columns.push(this.tablesTranslations.i18nDate, this.tablesTranslations.i18nCancellationNr,
      this.tablesTranslations.i18nInvoiceNr, this.tablesTranslations.i18nEventsAndTickets, this.tablesTranslations.i18nAmount);
    this.keys.push(['date', 'cancellationNumber', 'invoiceNumber', 'events', 'totalAmount'], ['', '', '', 'eventAndTicket', '']);
  }

  public ngOnInit(): void {
    this.getCustomerInvoicesEndpoint(this.customer.id);

    this.options = this.formBuilder.group({
      searchBy: ['', [Validators.minLength(2)]]
    });
  }

  public ngOnDestroy(): void {
  }

  /**
   * Selects the invoice and opens it in the sidepanel
   */
  public openInvoice(invoice: any): void {
    this.customerService.toggleAllModal(false);
    this.customerService.toggleInvoicesModal(true);
    this.invoiceService.setSelectedInvoice(invoice);
  }

  public getCustomerInvoicesEndpoint(id): void {
    const endpoint = this.invoiceService.getTicketCancellationsEndpoint(id);
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
    this.defaultCustomQueries = [...this.customQueries];
  }

  public setNewInvoiceList(invoices: Array<any>): any {
    const data: Array<CancellationTicket> = invoices.map(invoice => new CancellationTicket(invoice, this.invoiceOrderStatusTranslations));
    this.invoiceList = data;
  }

  /**
   * Triggers the search and updates the custom queries
   */
  public triggerSearch(): void {
    this.customQueries.length = 0;
    this.customQueries.push(...this.defaultCustomQueries);
    this.customQueries.push(this.options.value);
    this.paginatedTable.refetchData();
  }
}
